<template>
  <div>
    <div
      v-for="(bodyPart, index) in body"
      :key="`richText_bodyPart_${index}`"
    >
      <div v-if="bodyPart.type !== RICHTEXT_TYPE.TEXT">
        <component
          v-bind="bodyPart.value"
          :is="bodyPart.value.componentType"
        >
          <div
            v-for="(slotName, fieldName, slotIndex) in getSlots(bodyPart.value)"
            :slot="slotName"
            :key="slotName + slotIndex"
          >
            <RichText
              v-if="Array.isArray(bodyPart.value[fieldName])"
              :body="bodyPart.value[fieldName]"
            />
            <template v-else>
              {{ bodyPart.value[fieldName] }}
            </template>
          </div>
        </component>
      </div>
      <div
        v-else
        v-html="bodyPart.value"
      />
    </div>
  </div>
</template>

<script>
import { getComponentSlots } from '../index'
import { RICHTEXT_TYPE } from '../utils/constants/content'

export default {
  name: 'RichText',
  components: {
    FragmentComponent: () => import('./FragmentComponent.vue'),
    ZgButtonLink: () => import('@zc/components/ZgButtonLink/ZgButtonLink'),
    ZgCard: () =>
      import('@zc/components/ZgCard/ZgCard'),
    ZgCharts: () => import('@zc/components/ZgCharts/ZgCharts'),
    ZgDividedContent: () =>
      import('@zc/components/ZgDividedContent/ZgDividedContent'),
    ZgFaq: () => import('@zc/components/ZgFaq/ZgFaq'),
    ZgImage: () => import('@zc/components/ZgImage/ZgImage'),
    ZgInlineQuote: () => import('@zc/components/ZgInlineQuote/ZgInlineQuote')
  },
  props: {
    body: {
      type: Array,
      required: true,
      validator: (body) => body.every((obj) => obj.type && obj.value)
    }
  },
  data () {
    return {
      RICHTEXT_TYPE
    }
  },
  methods: {
    getSlots: (entry) => getComponentSlots(entry)
  }
}
</script>
